import React, { createContext, useContext, useEffect, useState } from "react";
import {
    getToken,
    getUser,
    setToken,
    setUser,
    login as apiLogin,
    fetchProfilim,
} from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [token, setTok] = useState(getToken());
    const [user, setUsr] = useState(getUser());
    const [loading, setLoading] = useState(false);
    const [profileLoading, setProfileLoading] = useState(!!getToken());

    const applyUser = (u) => {
        if (!u) {
            setUser(null);
            setUsr(null);
            return null;
        }
        setUser(u);
        setUsr(u);
        return u;
    };

    async function refreshProfile(cached) {
        if (cached) {
            return applyUser({ ...(getUser() || {}), ...cached });
        }
        const t = getToken();
        if (!t) return null;
        try {
            const data = await fetchProfilim();
            return applyUser({ ...(getUser() || {}), ...data });
        } catch {
            return getUser();
        }
    }

    useEffect(() => {
        const handler = () => {
            setTok(getToken());
            setUsr(getUser());
        };
        window.addEventListener("storage", handler);
        return () => window.removeEventListener("storage", handler);
    }, []);

    useEffect(() => {
        let cancelled = false;
        if (!token) {
            setProfileLoading(false);
            return undefined;
        }
        setProfileLoading(true);
        fetchProfilim()
            .then((data) => {
                if (!cancelled) applyUser({ ...(getUser() || {}), ...data });
            })
            .catch(() => {})
            .finally(() => {
                if (!cancelled) setProfileLoading(false);
            });
        return () => {
            cancelled = true;
        };
    }, [token]);

    async function signIn(username, password, otpPayload = null) {
        setLoading(true);
        try {
            const body = otpPayload
                ? { ...otpPayload }
                : { username, password };
            const data = await apiLogin(body);
            if (data?.otp_required) {
                return { otpRequired: true, ...data };
            }
            const t = data?.token || data?.key || data?.access;
            if (!t) {
                throw new Error("Sunucudan token alınamadı.");
            }
            setToken(t);
            setTok(t);
            const baseUser = data?.user ||
                data?.admin || {
                    username,
                    ...(data?.profile || {}),
                };
            applyUser(baseUser);
            await refreshProfile();
            return getUser() || baseUser;
        } finally {
            setLoading(false);
        }
    }

    function signOut() {
        setToken(null);
        setUser(null);
        setTok(null);
        setUsr(null);
    }

    return (
        <AuthContext.Provider
            value={{
                token,
                user,
                loading,
                profileLoading,
                signIn,
                signOut,
                refreshProfile,
                isAuthenticated: !!token,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used within AuthProvider");
    return ctx;
}
